<div class="dataset-failure-container" *ngIf="(isSyncingWithDelay$ | async) === false; else loading">
  <capra-icon class="dataset-error-icon" icon="illo-error-dataset"></capra-icon>
  <h4 class="header">Sorry, this Dataset can’t be displayed—the data failed to upload.</h4>

  <p>
    An error occurred while pulling the data in from Google. Make sure the Dataset creator is connected to their Google
    account and has access to the underlying Sheet and try again.
  </p>
  <div class="action-buttons">
    <capra-button-link
      class="check-sheet-btn"
      [href]="spreadsheetUrl"
      color="neutral"
      variant="secondary"
      text="Check Google Sheet"
      icon="icon-new-tab"
      iconLocation="right"
    ></capra-button-link>

    <capra-button class="retry-btn" [variant]="'primary'" [text]="'Retry'" (clicked)="onSyncClicked()"></capra-button>
  </div>
</div>

<ng-template #loading>
  <mode-loader class="loader"></mode-loader>
</ng-template>
